export const funcWithArity = (arity) => {
  const validator = (props, propName, componentName) => {
    const fn = props[propName];

    if (typeof fn !== "function") {
      return new Error(`${componentName}: ${propName} must be a function`);
    }

    if (fn.length !== arity) {
      return new Error(
        `${componentName}: ${propName} must declare exactly ${arity} parameters`
      );
    }

    return null;
  };

  validator.isRequired = (props, propName, componentName) => {
    if (props[propName] == null) {
      return new Error(`${componentName}: ${propName} is required`);
    }

    return validator(props, propName, componentName);
  };

  return validator;
};
